module.exports = __webpack_public_path__ + "static/media/privacy_fr.0ab833ab.txt";